<template>
  <div>Provider Uuid</div>
</template>

<script>
export default {
  //
};
</script>
